import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Swal from 'sweetalert2';
import Cookies from "js-cookie"

const API_BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your actual API base URL
// Fetch all media
export const fetchAllTravelMedia = createAsyncThunk(
  'travel/fetchAllTravelMedia',
  async (data, { rejectWithValue }) => {
    try {
      let {page,limit} = data
      const response = await axios.get(`${API_BASE_URL}/travel/fetch`,{
        params: {
          page,
          limit
        }
      });
      //console.log(response,"respone")
      return response.data;
    } catch (error) {
      //console.log(error,"travel/fetchtravel/fetch")
      return rejectWithValue(error.response.data);
    }
  }
);